import axios from "axios";
const moment = require("moment-timezone");

export default {
  install(Vue, store) {
    const helpers = new Helpers(store);
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  },
};

class Helpers {
  constructor(store) {
    this.store = store;
  }
  log(src, info, obj = null, splitArray = true) {
    console.log((src ? src.$options.name : "$helpers.log()") + " :: " + info);
    if (obj) {
      if (splitArray && Array.isArray(obj)) {
        obj.forEach((o) => {
          console.log(o);
        });
      } else {
        console.log(obj);
      }
    }
  }

  logDebug(info, obj = null) {
    this.log(null, info, obj, false);
  }

  truncate(str, n) {
    return str.length > n ? str.substr(0, n - 1) + "..." : str;
  }

  isSafari() {
    var browserInfo = this.getBrowserInfo();
    return browserInfo[0] == "Safari";
  }

  getBrowserInfo() {
    var nAgt = navigator.userAgent;
    var nameOffset, verOffset, ix;
    var browserName = "";
    var mobile = false;

    if ((verOffset = nAgt.indexOf("Opera")) != -1) {
      browserName = "Opera";
    } else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
      browserName = "Microsoft Internet Explorer";
    } else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
      browserName = "Chrome";
    } else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
      browserName = "Safari";
    } else if ((verOffset = nAgt.indexOf("iPhone")) != -1) {
      browserName = "Safari";
    } else if ((verOffset = nAgt.indexOf("iOS")) != -1) {
      browserName = "Safari";
    } else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
      browserName = "Firefox";
    } else if (
      (nameOffset = nAgt.lastIndexOf(" ") + 1) <
      (verOffset = nAgt.lastIndexOf("/"))
    ) {
      browserName = nAgt.substring(nameOffset, verOffset);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }
    if (
      nAgt.indexOf("iPhone") != -1 ||
      nAgt.indexOf("iOS") != -1 ||
      nAgt.indexOf("Android") != -1
    ) {
      mobile = true;
    }
    return [browserName, mobile];
  }

  appendParam(name, param, url, baseUrl) {
    if (!this.isBlank(param)) {
      if (url == baseUrl) {
        url += "?" + name + "=" + param;
      } else {
        url += "&" + name + "=" + param;
      }
    }
    return url;
  }

  loadTimeZone(zone) {}

  isEmpty(val) {
    if (val == undefined || val === "") return true;
    return false;
  }

  isBlank(str) {
    if (typeof str === "boolean" || this.isInt(str)) {
      return false;
    } else {
      return !str || /^\s*$/.test(str);
    }
  }

  isInt(value) {
    var x;
    if (isNaN(value)) {
      return false;
    }
    x = parseFloat(value);
    return (x | 0) === x;
  }

  roundNumber(number, decimals) {
    var mult = Math.pow(10, decimals);
    return Math.round(number * mult) / mult;
  }

  round2(number) {
    return this.roundNumber(number, 2);
  }

  euroInputToCents(input) {
    var inputFloat = input;

    if (typeof input === "string") {
      // fix decimal char and parse float value
      input = input.replace(",", ".");
      inputFloat = parseFloat(input);
    }

    var cents = Math.round(inputFloat * 100);
    return cents;
  }

  formatPayment(centValue) {
    if (centValue != null) {
      var euro = centValue / 100;
      var frmtEuro = euro.toFixed(2);
      frmtEuro = frmtEuro.replace(".", ",");
      return "€ " + frmtEuro;
    }
    return "";
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {
      type: mime,
    });
  }

  timeout(title, message) {
    return title.length * 60 + message.length * 60;
  }

  success(title, message) {
    window.app.popupmessages.push({
      startTime: new Date().getTime(),
      timer: this.timeout(title, message),
      type: "success",
      header: title,
      description: message,
    });
  }

  OpenPopup(state) {
    if (state && state.draggable && this.DragOpenedCheck()) return; //if you're already dragging a popup don't open it, it's better to put this here then on every mousedown function
    window.app.genericPopups.push(state);
    return state;
  }

  CheckDatafillKeysForHiddenInverted(...entryKeys) {
    if (!entryKeys.find) {
      let temp = [];
      temp.push(entryKeys);
      entryKeys = temp;
    }
    return (entries, entry) => {
      let value = false;
      if (!entries) {
        return value;
      }
      if (!entries.length) {
        entries = Object.values(entries);
      }
      if (entries.length) {
        value = !entryKeys.every((k) =>
          entries.find((e) => e.key === k && !e.value)
        );
      }
      return value;
    };
  }

  CheckDatafillKeysForHidden(...entryKeys) {
    if (!entryKeys.find) {
      let temp = [];
      temp.push(entryKeys);
      entryKeys = temp;
    }
    return (entries, entry) => {
      let value = false;
      if (!entries) {
        return value;
      }
      if (!entries.length) {
        entries = Object.values(entries);
      }
      if (entries.length) {
        value = entryKeys.every((k) =>
          entries.find((e) => e.key === k && !e.value)
        );
      }
      return value;
    };
  }

  warning(title, message) {
    window.app.popupmessages.push({
      startTime: new Date().getTime(),
      timer: this.timeout(title, message),
      type: "warning",
      header: title,
      description: message,
    });
  }

  error(title, message) {
    window.app.popupmessages.push({
      startTime: new Date().getTime(),
      timer: this.timeout(title, message),
      type: "error",
      header: title,
      description: message,
    });
  }

  info(title, message) {
    window.app.popupmessages.push({
      startTime: new Date().getTime(),
      timer: this.timeout(title, message),
      type: "info",
      header: title,
      description: message,
    });
  }

  formatDateStringTZ(datestr, format = null) {
    if (format != null) {
      if (this.store.state.companySettings.timeZone) {
        if (!this.isBlank(datestr)) {
          return moment
            .tz(datestr, this.store.state.companySettings.timeZone)
            .locale("de")
            .format(format);
        } else {
          return moment(datestr).format(format).locale("de");
        }
      }
    }
    return this.convertDateStringTZ(datestr);
  }

  convertDateString(datestr) {
    if (!this.isBlank(datestr)) {
      return moment(datestr).format("YYYY-MM-DDTHH:mmZ");
    } else {
      return null;
    }
  }

  convertDateStringUTC(datestr) {
    if (!this.isBlank(datestr)) {
      return moment.utc(datestr).format("YYYY-MM-DDTHH:mmZ");
    } else {
      return null;
    }
  }

  convertDateStringTZ(datestr) {
    if (this.store.state.companySettings.timeZone) {
      if (!this.isBlank(datestr)) {
        return moment
          .tz(datestr, this.store.state.companySettings.timeZone)
          .format("YYYY-MM-DDTHH:mmZ");
      } else {
        return null;
      }
    }
    return this.convertDateString(datestr);
  }

  convertDateTimeString(datestr, timestr) {
    if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
      return moment(datestr + "T" + timestr).format("YYYY-MM-DDTHH:mmZ");
    } else if (!this.isBlank(datestr)) {
      return moment(datestr + "T00:00:00").format("YYYY-MM-DDTHH:mmZ");
    } else if (!this.isBlank(timestr)) {
      return moment(timestr, "HH:mm").format("HH:mmZ");
    } else {
      return null;
    }
  }

  convertDateTimeStringUTC(datestr, timestr) {
    if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
      return moment.utc(datestr + "T" + timestr).format("YYYY-MM-DDTHH:mmZ");
    } else if (!this.isBlank(datestr)) {
      return moment.utc(datestr + "T00:00:00").format("YYYY-MM-DDTHH:mmZ");
    } else if (!this.isBlank(timestr)) {
      return moment.utc(timestr, "HH:mm").format("HH:mmZ");
    } else {
      return null;
    }
  }

  convertDateTimeStringTZ(datestr, timestr) {
    if (this.store.state.companySettings.timeZone) {
      if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
        return moment
          .tz(
            datestr + "T" + timestr,
            this.store.state.companySettings.timeZone
          )
          .format("YYYY-MM-DDTHH:mmZ");
      } else if (!this.isBlank(datestr)) {
        return moment
          .tz(datestr + "T00:00:00", this.store.state.companySettings.timeZone)
          .format("YYYY-MM-DDTHH:mmZ");
      } else if (!this.isBlank(timestr)) {
        return moment
          .tz(
            "2019-11-01T" + timestr,
            this.store.state.companySettings.timeZone
          )
          .format("HH:mmZ");
      } else {
        return null;
      }
    }
    return this.convertDateTimeString(datestr, timestr);
  }

  extractDateStringTZ(datestr, format = "YYYY-MM-DD") {
    if (this.store.state.companySettings.timeZone) {
      if (!this.isBlank(datestr)) {
        return moment
          .tz(datestr, this.store.state.companySettings.timeZone)
          .format(format);
      } else {
        return null;
      }
    }
    return this.extractDateString(datestr, format);
  }

  extractTimeStringTZ(str, format = "HH:mm") {
    if (this.store.state.companySettings.timeZone) {
      if (!this.isBlank(str)) {
        return moment
          .tz(str, "HH:mmZ", this.store.state.companySettings.timeZone)
          .format(format);
      } else {
        return null;
      }
    }
    return this.extractTimeString(datestr, format);
  }

  extractDateString(datestr, format = "YYYY-MM-DD") {
    if (!this.isBlank(datestr)) {
      return moment.utc(datestr).format(format);
    } else {
      return null;
    }
  }

  extractTimeString(str, format = "HH:mm") {
    if (!this.isBlank(str)) {
      return moment.utc(str, "HH:mmZ").format(format);
    } else {
      return null;
    }
  }

  getNowDateTimeString(format = "DD.MM.YYYY HH:mm") {
    return this.getMomentTZ().format(format);
  }

  getWeekDays() {
    return moment.weekdays();
  }

  getActualMoment(param = null) {
    if (param) {
      return moment(param).locale("de");
    }
    return moment;
  }

  getMoment() {
    return moment().locale("de");
  }

  getMomentUTC() {
    return moment.utc().locale("de");
  }

  getMomentTZ() {
    if (this.store.state.companySettings.timeZone) {
      //console.log("timezone");
      return moment.tz(this.store.state.companySettings.timeZone).locale("de");
    }
    return this.getMoment();
  }

  getMomentTZStartOfDay() {
    return this.getMomentTZ().hours(0).minutes(0).seconds(0).milliseconds(0);
  }

  getMomentFromString(str, format = "YYYY-MM-DDTHH:mmZ") {
    return moment(str, format).locale("de");
  }

  getMomentFromStringUTC(str, format = "YYYY-MM-DDTHH:mmZ") {
    return moment.utc(str, format).locale("de");
  }

  getMomentFromStringTZ(str, format = "YYYY-MM-DDTHH:mmZ") {
    if (this.store.state.companySettings.timeZone) {
      return moment
        .tz(str, format, this.store.state.companySettings.timeZone)
        .locale("de");
    }
    return this.getMomentFromString(str, format);
  }

  getNextMonthMoment() {
    return moment()
      .date(1)
      .hours(0)
      .minutes(0)
      .seconds(0)
      .milliseconds(0)
      .add(1, "M")
      .locale("de");
  }

  getNextMonthMomentUTC() {
    return moment
      .utc()
      .date(1)
      .hours(0)
      .minutes(0)
      .seconds(0)
      .milliseconds(0)
      .add(1, "M")
      .locale("de");
  }

  getNextMonthMomentTZ() {
    if (this.store.state.companySettings.timeZone) {
      return moment
        .tz(this.store.state.companySettings.timeZone)
        .date(1)
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
        .add(1, "M")
        .locale("de");
    }
    return this.getNextMonthMoment();
  }

  getCurrentMoment() {
    return moment().locale("de");
  }

  getCurrentMonthMoment() {
    return moment()
      .date(1)
      .hours(0)
      .minutes(0)
      .seconds(0)
      .milliseconds(0)
      .locale("de");
  }

  getCurrentMonthMomentUTC() {
    return moment
      .utc()
      .date(1)
      .hours(0)
      .minutes(0)
      .seconds(0)
      .milliseconds(0)
      .locale("de");
  }

  getCurrentMonthMomentTZ() {
    if (this.store.state.companySettings.timeZone) {
      return moment
        .tz(this.store.state.companySettings.timeZone)
        .date(1)
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
        .locale("de");
    }
    return this.getCurrentMonthMoment();
  }

  getMomentFromUnix(unix = 0) {
    return moment.unix(unix).locale("de");
  }

  getMomentFromUnixUTC(unix = 0) {
    return moment.utc().unix(unix).locale("de");
  }

  getMomentFromValues(
    year,
    month,
    day,
    hours = 0,
    minutes = 0,
    seconds = 0,
    milliseconds = 0
  ) {
    return moment()
      .year(year)
      .month(month)
      .date(day)
      .hours(hours)
      .minutes(minutes)
      .seconds(seconds)
      .milliseconds(milliseconds)
      .locale("de");
  }

  getMomentFromValuesUTC(
    year,
    month,
    day,
    hours = 0,
    minutes = 0,
    seconds = 0,
    milliseconds = 0
  ) {
    return moment
      .utc()
      .year(year)
      .month(month)
      .date(day)
      .hours(hours)
      .minutes(minutes)
      .seconds(seconds)
      .milliseconds(milliseconds)
      .locale("de");
  }

  getMomentFromValuesTZ(
    year,
    month,
    day,
    hours = 0,
    minutes = 0,
    seconds = 0,
    milliseconds = 0
  ) {
    if (this.store.state.companySettings.timeZone) {
      return moment
        .tz(this.store.state.companySettings.timeZone)
        .year(year)
        .month(month)
        .date(day)
        .hours(hours)
        .minutes(minutes)
        .seconds(seconds)
        .milliseconds(milliseconds)
        .locale("de");
    }
    return this.getMomentFromValues(
      year,
      month,
      day,
      hours,
      minutes,
      seconds,
      milliseconds
    );
  }

  getMomentDuration(start, end) {
    return moment.duration(end.diff(start)).locale("de");
  }

  gender(code) {
    switch (code) {
      case "M":
        return "männlich";
      case "F":
        return "weiblich";
      default:
        return "";
    }
  }

  salutation(code) {
    switch (code) {
      case "M":
        return "Herr";
      case "F":
        return "Frau";
      default:
        return "";
    }
  }

  getRandomLightColor() {
    let color = this.hslToHex(Math.random() * 360, 100, 75);
    return color;
  }

  hslToHex(h, s, l) {
    h /= 360;
    s /= 100;
    l /= 100;
    let r, g, b;
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      const hue2rgb = (p, q, t) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    const toHex = (x) => {
      const hex = Math.round(x * 255).toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    };
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  hexToHSLObject(H) {
    let r = 0,
      g = 0,
      b = 0;
    if (H.length === 4) {
      r = "0x" + H[1] + H[1];
      g = "0x" + H[2] + H[2];
      b = "0x" + H[3] + H[3];
    } else if (H.length === 7) {
      r = "0x" + H[1] + H[2];
      g = "0x" + H[3] + H[4];
      b = "0x" + H[5] + H[6];
    }
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b),
      cmax = Math.max(r, g, b),
      delta = cmax - cmin,
      h = 0,
      s = 0,
      l = 0;

    if (delta === 0) h = 0;
    else if (cmax === r) h = ((g - b) / delta) % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    if (h < 0) h += 360;

    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    return { h: h, s: s, l: l };
  }

  hexToRGBObject(H) {
    let r = 0,
      g = 0,
      b = 0;
    if (H.length === 4) {
      r = "0x" + H[1] + H[1];
      g = "0x" + H[2] + H[2];
      b = "0x" + H[3] + H[3];
    } else if (H.length === 7) {
      r = "0x" + H[1] + H[2];
      g = "0x" + H[3] + H[4];
      b = "0x" + H[5] + H[6];
    }
    r /= 1;
    g /= 1;
    b /= 1;

    return { r: r, g: g, b: b };
  }

  hexToHSL(H) {
    let hsl = this.hexToHSLObject(H);
    return "hsl(" + hsl.h + "," + hsl.s + "%," + hsl.l + "%)";
  }

  PopupNewEvent($event, date, copyEvents, createCallback) {
    var view = this;
    let copyEventItems = [];
    copyEventItems.push({
      label: "Standard",
      name: "Standard",
      value: null,
    });
    copyEvents.forEach((e) => {
      if (e.name == null) {
        e.name = e.label;
      }
      copyEventItems.push(e);
    });
    let from = date.clone().hours(0);

    let to = date.clone().hours(0).add(1, "days");

    let nameEntry = {
      label: "Name",
      key: "name",
      hidden: false,
      type: "text",
      value: "Event",
      length: 20,
    };
    let dataEntries = [
      {
        label: "von",
        key: "from",
        hidden: false,
        type: "timeframe",
        value: from,
        flexGroup: true,
        timeBig: true,
        startTime: true,
      },
      {
        label: "bis",
        key: "to",
        hidden: false,
        type: "timeframe",
        value: to,
        flexGroup: true,
        timeBig: true,
        endTime: true,
      },
      {
        divider: true,
      },
      nameEntry,
      {
        label: "Besetzung",
        key: "copyEventId",
        hidden: false,
        type: "dropdownsearch",
        value: null,
        selectMultiple: false,
        flexGroup: true,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: copyEventItems,
          selectMultiple: false,
          selectFirst: true,
          selectedItems: [],
          selectedItem: null,
          onceSelected: function ($event, item, searchbar) {
            if (view.isEmpty(nameEntry.value)) {
              nameEntry.value = item.name;
            }
          },
          styleLight: true,
        },
        styles: {
          width: "342px",
        },
      },
      {
        label: "Farbe",
        key: "color",
        hidden: false,
        type: "color",
        value: view.getRandomLightColor(),
      },
      {
        label: "Von Tag",
        key: "fromDate",
        hidden: false,
        type: "date",
        value: from.clone(),
        flexGroup: true,
        styles: {
          "margin-right": "10px",
        },
      },
      {
        label: "Bis Tag",
        key: "toDate",
        hidden: false,
        type: "date",
        value: to.clone(),
        flexGroup: true,
      },
      {
        flexDivider: true,
      },
      {
        label: "Gesetzlicher Feiertag",
        key: "federalHoliday",
        hidden: false,
        type: "bool",
        value: false,
        flexGroup: true,
      },
      {
        label: "Banken Feiertag",
        key: "bankHoliday",
        hidden: false,
        type: "bool",
        value: false,
        flexGroup: true,
      },
      {
        flexDivider: true,
      },
      {
        label: "Mit Templates erstellen",
        key: "createWithTemplates",
        hidden: false,
        type: "bool",
        value: true,
        flexGroup: true,
      },
      {
        label: "Beschreibung",
        key: "description",
        hidden: false,
        type: "text",
        value: "",
        length: 20,
      },
      {
        label: "Schicht Modus",
        key: "shiftCreationMode",
        hidden: false,
        type: "dropdownsearch",
        value: 0,
        selectMultiple: false,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: [
            {
              label: "Besetzung Ersatz",
              value: 0,
            },
            {
              label: "Besetzung Zusatz",
              value: 1,
            },
            {
              label: "Keine Schichten",
              value: 2,
            },
          ],
          selectMultiple: false,
          selectFirst: true,
          selectedItems: [],
          styleLight: true,
        },
      },
    ];
    let target = $event.currentTarget;

    this.OpenPopup({
      elRelative: target,
      type: "datafill",
      componentState: {
        entries: dataEntries,
        selectCallback: createCallback,
      },
      header: "Neues Event",
      expanded: true,
      centered: true,
    });
  }

  PopupEditEvent($event, event, editCallback) {
    let view = this;
    let from = event.fromMoment.clone();

    let to = event.toMoment.clone();

    let dataEntries = [
      {
        label: "Id",
        key: "id",
        hidden: true,
        type: "text",
        value: event.id,
        length: 20,
      },
      {
        label: "Name",
        key: "name",
        hidden: false,
        type: "text",
        value: "",
        length: 20,
      },
      {
        label: "Farbe",
        key: "color",
        hidden: false,
        type: "color",
        value: event.color,
      },
      {
        label: "Von Tag",
        key: "fromDate",
        hidden: false,
        type: "date",
        value: from.clone(),
      },
      {
        label: "Von",
        key: "from",
        hidden: false,
        type: "timeframe",
        value: from,
      },
      {
        label: "Bis Tag",
        key: "toDate",
        hidden: false,
        type: "date",
        value: to.clone(),
      },
      {
        label: "Bis",
        key: "to",
        hidden: false,
        type: "timeframe",
        value: to,
      },
      {
        label: "Gesetzlicher Feiertag",
        key: "federalHoliday",
        hidden: false,
        type: "bool",
        value: event.federalHoliday,
      },
      {
        label: "Banken Feiertag",
        key: "bankHoliday",
        hidden: false,
        type: "bool",
        value: event.bankHoliday,
      },
      {
        label: "Beschreibung",
        key: "description",
        hidden: false,
        type: "text",
        value: event.description,
        length: 20,
      },
      {
        label: "Schicht Modus",
        key: "shiftCreationMode",
        hidden: false,
        type: "dropdownsearch",
        value: event.shiftCreationMode,
        selectMultiple: false,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: [
            {
              label: "Besetzung Ersatz",
              value: 0,
            },
            {
              label: "Besetzung Zusatz",
              value: 1,
            },
            {
              label: "Keine Schichten",
              value: 2,
            },
          ],
          selectMultiple: false,
          selectFirst: false,
          selectedItems: [],
          styleLight: true,
        },
      },
    ];

    if (event) {
      for (let x in event) {
        let entry = dataEntries.find((e) => e.key === x);
        if (entry) {
          if (x === "from" || x === "to") {
            //do nothing cause datafill a shit
          } else if (x === "shiftCreationMode") {
            entry.dropdownSearchState.selectedItem = entry.dropdownSearchState.items.find(
              (i) => event[x] === i.value
            );
            if (entry.dropdownSearchState.selectedItem)
              entry.dropdownSearchState.input =
                entry.dropdownSearchState.selectedItem.label;
          } else {
            entry.value = event[x];
          }
        }
      }
    }
    let target = $event.currentTarget;

    this.OpenPopup({
      elRelative: target,
      type: "datafill",
      componentState: {
        entries: dataEntries,
        selectCallback: editCallback,
      },
      header: "Edit Event",
      expanded: true,
      centered: true,
    });
  }

  TimeDiff(a, b) {
    if (!a || !b || !a.format || !b.format) return NaN;
    return b._d.getTime() - a._d.getTime();
  }

  OpenAlert(state) {
    window.app.popupalerts.push({
      header: state.header,
      description: state.description,
      callbackAccept: state.callbackAccept,
      callbackCancel: state.callbackCancel,
      disableAccept: state.disableAccept ? state.disableAccept : false,
      disableCancel: state.disableCancel ? state.disableCancel : false,
      enableExternal: state.enableExternal ? state.enableExternal : false,
      externalUrl: state.externalUrl,
      externalLabel: state.externalLabel,
      acceptLabel: state.acceptLabel ? state.acceptLabel : "Ok",
      cancelLabel: state.cancelLabel ? state.cancelLabel : "Abbrechen",
    });
  }

  OpenDatepicker(state) {
    window.app.datepickerState = state;
  }

  /*
      sumArray should look like this if any
      let dataSum = [];
      let dataSumItem = {};
      let keyStart = Object.keys(headerMap)[0];
      dataSumItem[keyStart] = {key: keyStart, label: 'Total'};
      dataSumItem['amount'] = {key: amount, label: data.map(i => i.amount).reduce((total, current) => { return total + current})};
  */
  GetDataTableStateFromObject(dataItem, dataArray, sumArray) {
    let headerMap = {};

    for (let key in dataItem) {
      headerMap[key] = {
        key: key,
        DisplayLabel: (d) => d[key],
        sort: dataItem.sort ? dataItem.sort : null,
      };
    }

    return {
      headerMap: headerMap,
      data: dataArray ? dataArray : [],
      dataSum: sumArray ? sumArray : [],
    };
  }

  GetDataTableStateFromKeyLabelObject(dataItem, dataArray, sumArray) {
    let headerMap = {};

    for (let key in dataItem) {
      headerMap[key] = {
        key: key,
        label:
          dataItem[key] && dataItem !== ""
            ? dataItem[key]
            : this.ConvertKeyToName(key),
        DisplayLabel: (d) => d[key],
        sort: dataItem.sort ? dataItem.sort : null,
      };
    }

    return {
      headerMap: headerMap,
      data: dataArray ? dataArray : [],
      dataSum: sumArray ? sumArray : [],
    };
  }

  ConvertKeyToName(key) {
    if (key === undefined) return "";
    key = key.toString();
    let label = "";
    let temp = "";
    key
      .split("_")
      .filter((l) => l.length > 0)
      .forEach((l) => (temp += l[0].toUpperCase() + l.substr(1) + " "));
    label = temp;
    temp = "";
    label
      .split("-")
      .filter((l) => l.length > 0)
      .forEach((l) => (temp += l[0].toUpperCase() + l.substr(1) + " "));
    label = temp;
    temp = "";
    label
      .split(/(?=[A-Z])/)
      .filter((l) => l.length > 0)
      .forEach((l) => (temp += " " + l));
    label = temp;
    label = label.replace(/\s\s+/g, " ").trimRight();
    return label;
  }

  GetDataFillStateFromObject(object, selectCallback, asArray = false) {
    let dataEntries = {};
    if (asArray) {
      dataEntries = [];
    }
    for (let x in object) {
      let entry = {
        key: x,
        label: this.ConvertKeyToName(x),
        hidden: false,
        value: object[x],
        type: "text",
      };
      if (asArray) {
        dataEntries.push(entry);
      } else {
        dataEntries[x] = entry;
      }
    }

    return {
      entries: dataEntries,
      selectCallback: selectCallback,
    };
  }

  GetDataFillStateFromKeyLabelObject(object, selectCallback) {
    let dataEntries = {};
    for (let x in object) {
      dataEntries[x] = {
        key: x,
        label: object[x],
        hidden: false,
        value: null,
        type: "text",
      };
    }

    return {
      entries: dataEntries,
      selectCallback: selectCallback,
    };
  }

  GetCall(url, params) {
    return this.SendCall("get", url, params);
  }

  PostCall(url, payload, params = null) {
    let request = {
      payload: payload,
      params: params,
    };
    return this.SendCall("post2", url, request);
  }

  CreateCall(
    url,
    object,
    successCallback,
    successMessage,
    errorCallback,
    errorMessage
  ) {
    if (!successMessage) {
      successMessage = {
        title: "Erstellen",
        message: "Erstellen wurde erfolgreich durchgeführt",
      };
    }
    if (!errorMessage) {
      errorMessage = {
        title: "Erstellen",
        message: "Fehler beim Erstellen",
      };
    }
    return this.SendCall(
      "post",
      url,
      object,
      successCallback,
      successMessage,
      errorCallback,
      errorMessage
    );
  }

  EditCall(
    url,
    object,
    successCallback,
    successMessage,
    errorCallback,
    errorMessage
  ) {
    if (!successMessage) {
      successMessage = {
        title: "Update",
        message: "Update wurde erfolgreich durchgeführt",
      };
    }
    if (!errorMessage) {
      errorMessage = {
        title: "Update",
        message: "Fehler beim Update",
      };
    }
    return this.SendCall(
      "put",
      url,
      object,
      successCallback,
      successMessage,
      errorCallback,
      errorMessage
    );
  }

  DeleteCall(
    url,
    object,
    successCallback,
    successMessage,
    errorCallback,
    errorMessage
  ) {
    object = {
      id: object.id,
    };
    if (!successMessage) {
      successMessage = {
        title: "Löschen",
        message: "Löschen wurde erfolgreich durchgeführt",
      };
    }
    if (!errorMessage) {
      errorMessage = {
        title: "Löschen",
        message: "Fehler beim Löschen",
      };
    }
    return this.SendCall(
      "delete",
      url,
      object,
      successCallback,
      successMessage,
      errorCallback,
      errorMessage
    );
  }

  SendCall(
    type,
    url,
    object,
    successCallback,
    successMessage,
    errorCallback,
    errorMessage
  ) {
    let view = this;
    if (type === "put" || type === "post") {
      url = this.appendParam("storeId", this.store.state.storeId, url, url);
      let payload = {
        storeId: this.store.state.storeId,
      };
      for (let x in object) {
        if (type === "put" && x !== "id") {
          if (!payload.updateFields) payload.updateFields = [];
          payload.updateFields.push(x);
        }
        payload[x] = object[x];
      }

      return axios({
        method: type,
        headers: {
          AUTHORIZATION: "Bearer " + this.store.state.jwt,
        },
        url: url,
        data: payload,
      })
        .then((response) => {
          if (successMessage)
            view.success(successMessage.title, successMessage.message);
          if (successCallback) successCallback(response);
        })
        .catch(function (error) {
          if (errorMessage)
            view.error(errorMessage.title, errorMessage.message);
          if (errorCallback) errorCallback(error);
        });
    } else if (type === "post2") {
      url = this.appendParam("storeId", this.store.state.storeId, url, url);
      let payload = {
        storeId: this.store.state.storeId,
      };

      let params = object.params ? object.params : {};
      for (let x in object.payload) {
        if (type === "put" && x !== "id") {
          if (!payload.updateFields) payload.updateFields = [];
          payload.updateFields.push(x);
        }
        payload[x] = object.payload[x];
      }
      return axios({
        method: "post",
        params: params,
        headers: {
          AUTHORIZATION: "Bearer " + this.store.state.jwt,
        },
        url: url,
        data: payload,
      });
    } else if (type === "delete") {
      let urlTemp = "";
      urlTemp = this.appendParam("id", object.id, url, url);
      urlTemp = this.appendParam(
        "storeId",
        this.store.state.storeId,
        urlTemp,
        url
      );
      let axiosData = {
        method: type,
        headers: {
          AUTHORIZATION: "Bearer " + this.store.state.jwt,
        },
        url: urlTemp,
      };
      return axios(axiosData)
        .then((response) => {
          if (successMessage)
            view.success(successMessage.title, successMessage.message);
          if (successCallback) successCallback(response);
        })
        .catch(function (error) {
          if (errorMessage)
            view.error(errorMessage.title, errorMessage.message);
          if (errorCallback) errorCallback(error);
        });
    } else {
      url = this.appendParam("companyId", this.store.state.companyId, url, url);
      let axiosData = {
        method: type,
        headers: {
          AUTHORIZATION: "Bearer " + this.store.state.jwt,
        },
        url: url,
      };
      if (object) axiosData.params = object;
      return axios(axiosData);
    }
  }

  DateSelectionPopup($event, time, selectCallback, disableDate, disableTime) {
    let view = this;
    let state = this.GetDataFillStateFromObject(
      {
        date: time,
        timeframe: time,
      },
      (newTime) => {
        let date = view.getMomentFromStringTZ(newTime.date);
        let timeframe = view.getMomentFromStringTZ(newTime.timeframe);
        let time = date.hours(timeframe.hours).minutes(timeframe.minutes());
        selectCallback(view.convertDateString(time), time);
      }
    );

    state.entries.date.label = "";
    state.entries.date.type = "date";
    state.entries.date.dataStyles = disableTime
      ? {
          "justify-content": "center",
        }
      : {
          "justify-content": "flex-end",
        };
    state.entries.date.styles = {
      "margin-top": "-15px",
    };
    state.entries.date.hidden = disableDate;

    state.entries.timeframe.label = "Time";
    state.entries.timeframe.type = "timeframe";
    state.entries.timeframe.timeBig = true;
    state.entries.timeframe.flexGroup = true;
    state.entries.timeframe.hidden = disableTime;

    state.entries.divider = {
      divider: true,
      styles: {
        opacity: 0,
        margin: 0,
      },
    };

    let target = $event.currentTarget;

    this.OpenPopup({
      elRelative: target,
      type: "datafill",
      componentState: state,
      header: "Pick Date Time",
      expanded: true,
    });
  }

  returnObj(map, asArray) {
    /* this.log(null, 'returnObj', [map, asArray], false);
    this.log(null, 'returnObj', asArray? Object.values(map) : map, false); */
    return asArray ? Object.values(map) : map;
  }

  idObjectsArrayToMap(responseData) {
    var map = {};
    responseData.forEach((item) => {
      map[item.id] = item;
    });
    return map;
  }

  LoadMaps() {
    let view = this;
    let maps = {};
    view
      .GetCall("/api/sec/employee")
      .then((response) => {
        maps.employeeDataMap = response.data.data;
        window.maps = maps;
      })
      .catch((e) => {
        //view.error('Failed to load maps', e)
      });
  }

  async GetCompanyGroupsMap(force = false, asArray = false) {
    if (Object.values(this.store.state.companyGroupsMap).length > 0 && !force) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.companyGroupsMap, asArray));
      });
    } else {
      let params = {};
      return this.GetCall("/api/sec/list/companyGroups", params)
        .then((response) => {
          let map = response.data;
          this.store.commit("setCompanyGroupsMap", {
            companyGroupsMap: map,
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  async GetCompanyGroupsArray(force = false) {
    return this.GetCompanyGroupsMap(force, true);
  }

  async GetCompanyMap(force = false, asArray = false) {
    if (Object.values(this.store.state.companyMap).length > 0 && !force) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.companyMap, asArray));
      });
    } else {
      let params = {};
      return this.GetCall("/api/sec/list/company", params)
        .then((response) => {
          let map = response.data;
          this.store.commit("setCompanyMap", {
            companyMap: map,
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  async GetCompanyArray(force = false) {
    return this.GetCompanyMap(force, true);
  }

  GetCompanySettings(force = false, asArray = false) {
    if (
      this.store.state.companySettings &&
      this.store.state.companySettings.id == this.store.state.companyId &&
      !force
    ) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.companySettings, asArray));
      });
    } else {
      let params = {
        companyId: this.store.state.companyId,
      };
      return this.GetCall("/api/sec/company", params)
        .then((response) => {
          let map = response.data;

          this.store.commit("setCompanySettings", {
            companySettings: map,
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  GetStoresSettings(force = false, asArray = false) {
    if (
      this.store.state.storesSettings &&
      this.store.state.companySettings.id == this.store.state.companyId &&
      !force
    ) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.storesSettings, asArray));
      });
    } else {
      let params = {
        companyId: this.store.state.companyId,
      };
      return this.GetCall("/api/sec/stores", params)
        .then((response) => {
          let map = response.data;

          this.store.commit("setStoresSettings", {
            storesSettings: map,
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }
  GetStoresSettingsArray(force = false) {
    return this.GetStoresSettings(force, true);
  }

  GetStores(force = false, asArray = false) {
    if (
      this.store.state.storeMap &&
      this.store.state.companySettings.id == this.store.state.companyId &&
      !force
    ) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.storeMap, asArray));
      });
    } else {
      let params = {
        companyId: this.store.state.companyId,
      };
      return this.GetCall("/api/sec/stores", params)
        .then((response) => {
          // TODO: this response is paginated by default but with 2000 elements per page -->
          // unrealistic that a single company receives 2 pages of stores here, anyways it would be cleaner to attempt to load all pages of data
          let map = response.data.data;

          this.store.commit("setStoreMap", {
            storeMap: map,
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }
  GetStoresArray(force = false) {
    return this.GetStores(force, true);
  }

  GetSelectedStores(force = false) {
    if (this.store.state.selectedStores && !force) {
      return new Promise((resolve, reject) => {
        resolve(this.store.state.selectedStores);
      });
    } else {
      console.log("Loading selected stores from local storage");
      let selectedLS = localStorage.getItem("selectedStores");
      let stores = undefined;
      console.log(selectedLS);
      if (selectedLS != undefined) {
        let seljson = JSON.parse(selectedLS);
        stores = seljson.stores;
      }
      console.log(stores);
      this.store.commit("setSelectedStores", {
        selectedStores: stores,
      });
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(stores, true));
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    }
  }

  GetEmployeeMap(force = false, asArray = false) {
    /* this.log(null, 'GetEmployeeMap', [force, asArray], false); */
    if (
      this.store.state.employeeMap &&
      this.store.state.employeeMapState.storeId == this.store.state.storeId &&
      this.store.state.employeeMapState.type == "all" &&
      !force
    ) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.employeeMap, asArray));
      });
    } else {
      return this.GetCall("/api/sec/employee")
        .then((response) => {
          let map = {};
          response.data.data.forEach((employee) => {
            map[employee.id] = employee;
          });
          this.store.commit("setEmployeeMap", {
            employeeMap: map,
            type: "all",
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  GetEmployeeArray(force = false) {
    /* this.log(null, 'GetEmployeeArray', force); */
    return this.GetEmployeeMap(force, true);
  }

  GetActiveEmployeeMap(force = false, asArray = false) {
    console.log("GET Active EmployeeMap");
    if (
      this.store.state.employeeMap &&
      this.store.state.employeeMapState.storeId == this.store.state.storeId &&
      this.store.state.employeeMapState.type == "active" &&
      this.store.state.employeeMapState.rosterFromToKey ==
        this.store.getters.rosterFromToKey &&
      !force
    ) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.employeeMap, asArray));
      });
    } else {
      let params = {
        active: true,
        activeAtFrom: this.store.state.rosterFromTo.from,
        activeAtTo: this.store.state.rosterFromTo.to,
      };
      return this.GetCall("/api/sec/employee", params)
        .then((response) => {
          let map = {};
          response.data.data.forEach((employee) => {
            map[employee.id] = employee;
          });
          this.store.commit("setEmployeeMap", {
            employeeMap: map,
            type: "active",
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }
  GetActiveEmployeeArray(force = false) {
    return this.GetActiveEmployeeMap(force, true);
  }

  CalculateWorkDaysCount(date) {
    let storeSettings = this.store.state.storeSettings;
    let workDays = storeSettings ? storeSettings.workDays : [1, 2, 3, 4, 5];
    let start = date.clone().startOf("month");
    let end = start.clone().endOf("month").add(1, "days").startOf("day");
    let result = 0;
    while (end > start) {
      if (workDays.includes(start.isoWeekday())) {
        result += 1;
      }
      start = start.add(1, "days");
    }
    console.log("CalcWorkDays: " + result);
    return result;
  }

  CalculateDaysCount(date) {
    let start = date.clone().startOf("month");
    let end = start.clone().endOf("month").add(1, "days").startOf("day");
    let result = end.diff(start, "days");

    console.log("CalcDays: " + result);
    return result;
  }

  CalculateMonthWorkTime(workDays, days, weekTime, weekDays, monthAvgFactor) {
    let storeSettings = this.store.state.storeSettings;
    let mode = storeSettings ? storeSettings.workTimeMode : 0;
    let factor = monthAvgFactor
      ? monthAvgFactor / Math.pow(10, 7)
      : storeSettings
      ? storeSettings.workTimeFactor / Math.pow(10, 7)
      : 4.325;

    if (mode == 2) {
      let dayWorkTime = weekTime / 7;
      return Math.round(dayWorkTime * days);
    } else if (mode == 1) {
      let dayWorkTime = weekTime / weekDays;
      return Math.round(dayWorkTime * workDays);
    } else {
      return Math.round(weekTime * factor);
    }
  }

  // HELPERS FOR REPORTS

  reportDoc(
    title,
    subtitle = null,
    subtitle2 = null,
    userFullname = null,
    orientation = "p",
    headerImgData = null
  ) {
    var doc = new jsPDF({
      orientation: orientation,
    });
    var tmpFill = doc.getFillColor();
    var tmpFontSize = doc.getFontSize();
    var tmpTextColor = doc.getTextColor();

    var y = 20;
    var headerRightOffset = orientation == "l" ? 265 : 178;
    var titleX = 14;
    if (headerImgData != null) {
      titleX = 33;
      doc.setFillColor(109, 141, 33);
      doc.rect(14, 16, 16, 16, "F");
      doc.addImage(headerImgData, "png", 14.5, 16.5, 15, 15);
    }

    doc.text(title, titleX, y);
    y += 5;
    doc.setFontSize(10);
    if (subtitle != null) {
      doc.text(subtitle, titleX, y);
      y += 4;
    }
    if (subtitle2 != null) {
      doc.text(subtitle2, titleX, y);
      y += 6;
    }
    doc.setFontSize(8);
    var img =
      "data:image/png;base64,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";
    var created = this.getNowDateTimeString();
    doc.addImage(img, "png", headerRightOffset + 3, 17, 15, 15);
    doc.text("erstellt am: " + created, headerRightOffset, 20, {
      align: "right",
    });
    if (userFullname != null)
      doc.text("erstellt von: " + userFullname, headerRightOffset, 24, {
        align: "right",
      });

    // reapply previous settings
    doc.setFillColor(tmpFill);
    doc.setFontSize(tmpFontSize);
    doc.setTextColor(tmpTextColor);
    doc.setFontStyle("normal");
    return {
      doc: doc,
      contentOffsetY: 35,
    };
  }

  employeeDataReportDoc(name, employeePictureData) {
    return this.reportDoc(
      name,
      "Personaldatenblatt",
      null,
      null,
      "p",
      employeePictureData
    );
  }

  tableReportDoc(
    headers,
    title,
    subtitle = null,
    subtitle2 = null,
    userFullname = null,
    orientationBreakpoint = 8
  ) {
    var orientation = headers.length >= orientationBreakpoint ? "l" : "p";
    return this.reportDoc(
      title,
      subtitle,
      subtitle2,
      userFullname,
      orientation
    );
  }

  reportHeaderColorBlock(doc, title, offsetY) {
    var tmpFill = doc.getFillColor();
    var tmpFontSize = doc.getFontSize();
    var tmpTextColor = doc.getTextColor();

    doc.setFillColor(109, 141, 33);
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFontStyle("bold");
    doc.rect(14, offsetY, 182, 10, "F");
    offsetY += 7;
    doc.text(title, 16, offsetY);
    offsetY += 8;

    // reapply previous settings
    doc.setFillColor(tmpFill);
    doc.setFontSize(tmpFontSize);
    doc.setTextColor(tmpTextColor);
    doc.setFontStyle("normal");

    return doc, offsetY;
  }

  reportColorBlockDivider(doc, offsetY) {
    var tmpFill = doc.getFillColor();

    doc.setFillColor(200, 200, 200);
    doc.rect(14, offsetY, 182, 5, "F");
    offsetY += 10;

    // reapply previous settings
    doc.setFillColor(tmpFill);

    return doc, offsetY;
  }

  reportSubHeaderColorBlock(doc, title, offsetY) {
    var tmpFill = doc.getFillColor();
    var tmpFontSize = doc.getFontSize();
    var tmpTextColor = doc.getTextColor();

    doc.setFillColor(109, 141, 33);
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFontStyle("bold");
    doc.rect(14, offsetY, 182, 10, "F");
    offsetY += 7;
    doc.text(title, 16, offsetY);
    offsetY += 8;

    // reapply previous settings
    doc.setFillColor(tmpFill);
    doc.setFontSize(tmpFontSize);
    doc.setTextColor(tmpTextColor);
    doc.setFontStyle("normal");

    return doc, offsetY;
  }

  dataBlock(doc, data, offsetX, offsetY, page) {
    var tmpFill = doc.getFillColor();
    var tmpFontSize = doc.getFontSize();
    var tmpTextColor = doc.getTextColor();
    var offset = {
      offsetY: offsetY,
      page: page,
    };
    var lineHeight = 4;
    var left = 50 + offsetX;
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    data.forEach((d) => {
      var key = d.key;
      var value = d.value;
      doc.setFontStyle("normal");
      doc.text(key + (key != "" ? ":" : ""), left, offsetY, {
        align: "right",
      });
      doc.setFontStyle("bold");
      doc.text(value != null ? value : "", left + 3, offsetY);
      offsetY += lineHeight;
      doc, (offset = this.checkOffsetForNewPage(doc, offsetY, page));
      offsetY = offset.offsetY;
      page = offset.page;
    });

    // reapply previous settings
    doc.setFillColor(tmpFill);
    doc.setFontSize(tmpFontSize);
    doc.setTextColor(tmpTextColor);
    doc.setFontStyle("normal");
    return (
      doc,
      {
        offsetY: offsetY,
        page: page,
      }
    );
  }

  checkOffsetForNewPage(doc, offsetY, page) {
    // doc.rect(13.9, curY-0.2, 182.2, 297 - curY - 15);
    if (offsetY > 297 - 20) {
      var pageCount = doc.internal.getNumberOfPages();
      if (page == pageCount) {
        doc.addPage();
        page++;
      } else {
        page++;
        doc.setPage(page);
      }
      offsetY = 15;
      doc.rect(13.9, offsetY, 182.2, 297 - offsetY - 15);
      offsetY = 25;
    }

    return (
      doc,
      {
        offsetY: offsetY,
        page: page,
      }
    );
  }

  insertPageNumbers(doc, landscape = false) {
    var tmpFontSize = doc.getFontSize();
    var tmpTextColor = doc.getTextColor();

    var offsetX = 105;
    var offsetY = 287;
    if (landscape) {
      offsetX = 148.5;
      offsetY = 200;
    }

    doc.setFontStyle("normal");
    doc.setFontSize(6);
    doc.setTextColor(60, 60, 60);

    var pageCount = doc.internal.getNumberOfPages();
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.text("Seite " + i + " von " + pageCount, offsetX, offsetY, {
        align: "center",
      });
    }
    doc.setFontSize(tmpFontSize);
    doc.setTextColor(tmpTextColor);
    return doc;
  }

  getImageDataUri(url, cb) {
    var image = new Image();
    image.setAttribute("crossOrigin", "anonymous"); //getting images from external domain

    image.onload = function () {
      var canvas = document.createElement("canvas");
      canvas.width = this.naturalWidth;
      canvas.height = this.naturalHeight;

      //next three lines for white background in case png has a transparent background
      var ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff"; /// set white fill style
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      canvas.getContext("2d").drawImage(this, 0, 0);

      cb(canvas.toDataURL("image/jpeg"));
    };

    image.src = url;
  }

  ProcessNumericLabel(label, decimals = 2, divider = ",", plusSign = true) {
    let number = parseFloat(label);
    if (!isNaN(number)) {
      number = (Math.round(number * 100) / 100).toFixed(decimals);
      if (plusSign) {
        number = (number < 0 ? "" : "+") + number;
      }
      label = number.toString().replace(".", divider);
    }
    return label;
  }

  GetSnapShot(el, name, callbackSnapTaken) {
    let box = el.getBoundingClientRect();
    html2canvas(el, {
      //canvas:canvas,
      height: 1920,
      width: 1080,
    })
      .then((canvas) => {
        let image = canvas.toDataURL("image/png");
        let imageDownloadElement = document.createElement("a");
        imageDownloadElement.href = image;
        imageDownloadElement.download = (name ? name : "download") + ".png";
        document.body.appendChild(imageDownloadElement);
        imageDownloadElement.click();
        document.body.removeChild(imageDownloadElement);
        if (callbackSnapTaken) callbackSnapTaken();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  DragOpenedCheck() {
    return window.app.genericPopups.find((p) => p.draggable);
  }

  OpenListLabel(labels, options) {
    let defaultState = {
      components: [
        {
          type: "listlabel",
          state: {
            labels: labels,
          },
        },
      ],
      listStyle: true,
      noScroll: true,
      pointerDirection: 3,
      elRelative: null,
      pointerOffset: 0,
      pointerHide: true,
      pinTopRight: true,
    };
    if (options) for (let x in options) defaultState[x] = options[x];
    /*if(defaultState.elRelative) {
        defaultState.offsety = defaultState.elRelative.getBoundingClientRect().height / 2;
    }*/

    this.OpenPopup(defaultState);
  }

  TimeBarDragCheck(shift) {
    var shiftDragged = shift;
    return (elementOnMouseCursor) => {
      let timebar = $(elementOnMouseCursor).closest(".time-bar-new")[0];

      if (timebar) {
        console.log("timebar dragged unto");
        timebar = timebar.__vue__;
        timebar.AddTimeFrameDrag(shiftDragged);
      }
    };
  }

  EndShiftDrag(rosterView, dropdowncontainer) {
    $(".dragged-shift").removeClass("dragged-shift");
    $(".shift-drag-overlay").css("display", "");
    rosterView.dragging = false;
    rosterView.ClearEmployeeFilter();
    dropdowncontainer.Close();
    window.app.MouseMoveUnsubscribe("TimeBarShiftDragCheck");
    if (window.timebars) {
      window.timebars.filter((t) => t).forEach((t) => (t.timeFrameDrag = null));
    }
  }

  DragShift(shifts, rosterView, shiftDraggedElement) {
    if (shifts && !shifts.length) {
      let array = [];
      array.push(shifts);
      shifts = array;
    }
    if (
      !shifts ||
      shifts.length === 0 ||
      shifts[0].length === 0 ||
      !shifts.find((s) => !s.published)
    )
      return;
    let view = this;
    setTimeout(function () {
      if (!window.mouse.click) return;
      window.app.MouseMoveSubscribe(
        "TimeBarShiftDragCheck",
        view.TimeBarDragCheck(shifts[0])
      );
      rosterView.dragging = true;
      shifts.forEach((s) => rosterView.FilterSpot(s.spotId, true));
      rosterView.filterEmployees();
      if (shiftDraggedElement) {
        let draggedBox = shiftDraggedElement.getBoundingClientRect();
        $(shiftDraggedElement).addClass("dragged-shift");
        requestAnimationFrame(function () {
          $(".shift-drag-overlay").css("display", "inline-block");
          let firstWeek = $(
            ".entry > .week:first-child"
          )[0].getBoundingClientRect();
          let lastWeek = $(
            ".entry > .week:last-child"
          )[0].getBoundingClientRect();
          $(".shift-drag-overlay.left").css({
            width: draggedBox.left - firstWeek.left + "px",
            left: firstWeek.left + "px",
          });
          $(".shift-drag-overlay.right").css({
            left: draggedBox.right + "px",
            width: lastWeek.right - draggedBox.right + "px",
          });
        });
      }
      let components = [];
      let draggedUntoSelection = {};
      for (let x in shifts) {
        components.push({
          type: "rosterday",
          state: {
            shifts: shifts,
            spotMap: rosterView.spotMap,
          },
          /*propContainer: {
              eventProp: rosterView.GetTimeBarShiftProp(rosterView.planShiftMomentMap[shifts[x].id].fromDate, shifts[x]),
              class: shifts[x].published ? 'published' : '',
          },*/
          customEvent: {},
          click: (dropdowncontainer, component) => {
            if (draggedUntoSelection.shifts.length > 0) {
              rosterView.$helpers.OpenShiftDragSubMenu(
                shifts[0],
                draggedUntoSelection,
                component.$el,
                dropdowncontainer,
                rosterView
              );
            } else {
              rosterView.UpdateShift(component.eventProp.timeFrames[0].shift, {
                employeeId: draggedUntoSelection.employee.id,
              });
              view.EndShiftDrag(rosterView, dropdowncontainer);
            }
          },
        });
      }
      rosterView.$helpers.OpenPopup({
        components: components,
        listStyle: true,
        noScroll: true,
        draggable: true,
        remainAfterSelect: true,
        allowOverflow: true,
        callbackDrag: (element, dropdowncontainer) => {
          if ($(element).closest(".shifts")[0]) {
            rosterView.UpdateShift(shifts[0], { employeeId: null });
            view.EndShiftDrag(rosterView, dropdowncontainer);
            return;
          }
          let day = $(element).closest(".entry:not(.header) .day")[0];
          if (day) {
            draggedUntoSelection.employee =
              rosterView.employeeMap[day.attributes.employeeid.value];
            draggedUntoSelection.shifts =
              rosterView.rosterContentMap[day.attributes.employeeid.value][
                day.attributes.date.value
              ].planShifts;
            draggedUntoSelection.date = rosterView.$helpers.getMomentFromStringTZ(
              day.attributes.date.value
            );
            if (
              draggedUntoSelection.shifts.length === 0 &&
              shifts.length === 1
            ) {
              rosterView.UpdateShift(shifts[0], {
                employeeId: draggedUntoSelection.employee.id,
              });
              view.EndShiftDrag(rosterView, dropdowncontainer);
            }
            if (
              draggedUntoSelection.shifts.length === 1 &&
              shifts.length === 1
            ) {
              if (draggedUntoSelection.employee.id === shifts[0].employeeId) {
                view.EndShiftDrag(rosterView, dropdowncontainer);
              } else {
                rosterView.$helpers.OpenShiftDragSubMenu(
                  shifts[0],
                  draggedUntoSelection,
                  day,
                  dropdowncontainer,
                  rosterView
                );
                requestAnimationFrame(function () {
                  view.EndShiftDrag(rosterView, dropdowncontainer);
                });
              }
            }
          } else {
            let timebar = $(element).closest(".time-bar-new")[0];

            if (timebar) {
              timebar = timebar.__vue__;
              draggedUntoSelection.employee = timebar.eventProp.employee;

              draggedUntoSelection.shifts = timebar.timeFrames
                .filter((t) => t.type == "shift")
                .map((t) => t.shift);
              let array = [];

              draggedUntoSelection.shifts.forEach((s) => {
                if (!array.find((a) => a.id === s.id)) {
                  if (
                    rosterView.planShiftMomentMap[s.id] &&
                    rosterView.planShiftMomentMap[s.id].fromDate.date() ===
                      timebar.eventProp.day.date()
                  )
                    array.push(s);
                  if (
                    rosterView.actualShiftMomentMap[s.id] &&
                    rosterView.actualShiftMomentMap[s.id].fromDate.date() ===
                      timebar.eventProp.day.date()
                  )
                    array.push(s);
                }
              });
              draggedUntoSelection.shifts = array;
              draggedUntoSelection.date = timebar.eventProp.day.clone();
              if (
                draggedUntoSelection.shifts.length === 0 &&
                shifts.length === 1
              ) {
                rosterView.UpdateShift(shifts[0], {
                  employeeId: draggedUntoSelection.employee.id,
                });
                view.EndShiftDrag(rosterView, dropdowncontainer);
              }
              if (
                draggedUntoSelection.shifts.length === 1 &&
                shifts.length === 1
              ) {
                if (draggedUntoSelection.employee.id === shifts[0].employeeId) {
                  view.EndShiftDrag(rosterView, dropdowncontainer);
                } else {
                  rosterView.$helpers.OpenShiftDragSubMenu(
                    shifts[0],
                    draggedUntoSelection,
                    null,
                    dropdowncontainer,
                    rosterView
                  );
                  requestAnimationFrame(function () {
                    view.EndShiftDrag(rosterView, dropdowncontainer);
                  });
                }
              }
            } else {
              view.EndShiftDrag(rosterView, dropdowncontainer);
            }
          }
        },
      });
    }, 200);
  }

  OpenShiftDragSubMenu(
    shift,
    draggedUntoSelection,
    element,
    dropdowncontainer,
    rosterView
  ) {
    let labelOptions = [];
    let helpers = this;
    let view = this;

    let overlap = draggedUntoSelection.shifts.find((s) =>
      helpers.CheckTimeFrameIntersect(
        rosterView.planShiftMomentMap[shift.id].fromDate,
        rosterView.planShiftMomentMap[shift.id].toDate,
        rosterView.planShiftMomentMap[s.id].fromDate,
        rosterView.planShiftMomentMap[s.id].toDate
      )
    );

    let addOption = {
      text: "Hinzufügen",
      type: "block",
      click: () => {
        rosterView.UpdateShift(shift, {
          employeeId: draggedUntoSelection.employee.id,
        });
        view.EndShiftDrag(rosterView, dropdowncontainer);
      },
    };

    if (overlap) {
      addOption.disabled = true;
      addOption.tooltip = "Überlappung";
    }

    labelOptions.push(addOption);
    let draggedUntoShift = draggedUntoSelection.shifts[0];
    if (draggedUntoShift) {
      labelOptions.push({
        text: "Tauschen",
        type: "block",
        click: () => {
          let draggedEmployeeId = shift.employeeId;
          let shiftUpdateRequests = [];
          shiftUpdateRequests.push({
            shift: shift,
            fields: { employeeId: draggedUntoSelection.employee.id },
          });
          shiftUpdateRequests.push({
            shift: draggedUntoShift,
            fields: { employeeId: draggedEmployeeId },
          });
          rosterView.UpdateShiftMulti(shiftUpdateRequests);
          //rosterView.UpdateShift(shift, {employeeId: draggedUntoSelection.employee.id});
          //rosterView.UpdateShift(draggedUntoSelection.shifts[0], {employeeId: draggedEmployeeId});
          console.log("Tauschen " + draggedUntoSelection.employee.firstName);
          view.EndShiftDrag(rosterView, dropdowncontainer);
        },
        disabled: draggedUntoShift.published,
        tooltip: draggedUntoShift.published ? "Bereits veröffentlicht" : null,
      });
      labelOptions.push({
        text: "Ersetzen",
        type: "block",
        click: () => {
          rosterView.UpdateShift(shift, {
            employeeId: draggedUntoSelection.employee.id,
          });
          rosterView.UpdateShift(draggedUntoShift, { employeeId: null });
          console.log("Ersetzen " + draggedUntoSelection.employee.firstName);
          view.EndShiftDrag(rosterView, dropdowncontainer);
        },
        disabled: draggedUntoShift.published,
        tooltip: draggedUntoShift.published ? "Bereits veröffentlicht" : null,
      });
    }

    rosterView.$helpers.OpenListLabel(labelOptions, {
      elRelative: element,
      pointerHide: true,
      pointerDirection: 3,
    });
  }

  CheckTimeFrameIntersect(startA, endA, startB, endB) {
    return startA < endB && startB < endA;
  }

  IsKeyNameNavigationType(keyName) {
    return (
      keyName === "Home" ||
      keyName === "End" ||
      keyName === "PageUp" ||
      keyName === "PageDown" ||
      keyName === "ArrowLeft" ||
      keyName === "ArrowRight" ||
      keyName === "Backspace" ||
      keyName === "Delete" ||
      keyName === "Tab" ||
      keyName === "Shift"
    );
  }

  OpenDatepickerPopup(dateOptions, dateEvents, popupOptions) {
    /* example datepicker
        dateOptions = {viewsEnabled: ['W','M','Y','C'], date: dateMoment}
        dateEvents = {
            OnDateSelect: (date) => {...}, //always called to avoid having to define it x5 for a generic date pick
            OnWeekSelect: (date) => {...}, //you don't have to define these or OnDateSelect if you're not using them
            OnDaySelect: (date) => {...},
            OnMonthSelect: (date) => {...},
            OnYearSelect: (date) => {...},
            OnCalendarSelect: (date) => {...},
        };
        popupOptions: {elRelative: $event.currentTarget} // if elRelative isn't defined the popup will open on the cursor so no big deal
    */
    let defaultState = {
      components: [
        {
          type: "datepicker",
          state: dateOptions,
          customEvents: dateEvents,
        },
      ],
      noScroll: true,
      pointerDirection: 3,
      elRelative: null,
      pointerOffset: 0,
      pointerHide: true,
      pinTopRight: true,
      expanded: true,
    };
    if (popupOptions)
      for (let x in popupOptions) defaultState[x] = popupOptions[x];

    this.OpenPopup(defaultState);
  }

  GetContrastingColor(
    hex,
    lightcolor = "white",
    darkcolor = "#444444",
    contrastLimit = 80
  ) {
    if (!hex) return darkcolor;
    let hsl = this.hexToHSLObject(hex);
    if (hsl.l < contrastLimit) return lightcolor;
    else return darkcolor;
  }

  OpenDragPopup(
    popupOptions,
    dragEndCallback = (elementOnMouse, dropdowncontainer) => {}
  ) {
    let defaultState = {
      components: [],
      listStyle: true,
      noScroll: true,
      draggable: true,
      remainAfterSelect: true,
      callbackDrag: dragEndCallback,
    };
    if (popupOptions)
      for (let x in popupOptions) defaultState[x] = popupOptions[x];
    this.OpenPopup(defaultState);
  }

  SetMomentTimeFromMoment(momentExisting, momentToCopy) {
    momentExisting.year(momentToCopy.year());
    momentExisting.month(momentToCopy.month());
    momentExisting.date(momentToCopy.date());
    momentExisting.hours(momentToCopy.hours());
    momentExisting.minutes(momentToCopy.minutes());
    momentExisting.seconds(momentToCopy.seconds());
    momentExisting.milliseconds(momentToCopy.milliseconds());
    return momentExisting;
  }

  GetHourMinuteFormatFromTotal(total) {
    if (!total) return "--:--";
    if (!total.totalActual)
      return this.GetHourMinuteFormatFromMilliseconds(
        total.total + total.totalPreviousDay
      );
    return this.GetHourMinuteFormatFromMilliseconds(
      total.totalActual + total.totalActualPreviousDay
    );
  }

  GetHourMinuteFormatFromMap(map, format) {
    if (!map || !map[format]) return "--:--";
    return this.GetHourMinuteFormatFromTotal(map[format]);
  }

  GetHourMinuteFormatFromMilliseconds(milliseconds) {
    if (!milliseconds) return "--:--";
    let seconds = milliseconds / 1000;
    let minutes = seconds / 60;

    let hours = (minutes - (minutes % 60)) / 60;
    minutes = Math.ceil(minutes % 60);
    if (minutes === 60) {
      hours++;
      minutes = 0;
    }
    if (minutes < 10) minutes = "0" + minutes;
    if (hours < 10) hours = "0" + hours;

    return hours + "h:" + minutes + "m";
  }

  GetMillisecondTotalObjectFromMoments(from, to, timeBorderMoment) {
    let difference = 0;
    let remaining = 0;
    if (!timeBorderMoment) {
      difference += to._d.getTime() - from._d.getTime();
    } else {
      if (to < timeBorderMoment) {
        difference += to._d.getTime() - from._d.getTime();
      } else {
        difference += timeBorderMoment._d.getTime() - from._d.getTime();
        remaining += to._d.getTime() - timeBorderMoment._d.getTime();
      }
    }
    return { total: difference, totalOutOfRange: remaining };
  }
  //example

  //this.$helpers.OpenColorSelection(
  //  (color) => {
  //      store.color = color;
  //      view.$forceUpdate();
  //  },
  //  {
  //      header: 'Wahl-Farben',
  //      colorSelection: this.spotsStructured.map(s => { return s.color}),
  //      colorSelected: store.color,
  //      colorBlacklist: this.spotsStructured.map(s => { return {color: s.color, label: s.name}})
  //  }
  //);
  //
  //or just for default values
  //this.$helpers.OpenColorSelection((color) => { store.color = color; }},

  OpenColorSelection(callback, options = {}) {
    this.OpenPopup({
      expanded: true,
      noScroll: true,
      header: options.header ? options.header : "Wahl-Farben",
      components: [
        {
          type: "colorselection",
          customEvents: { ApplyColor: callback },
          propContainer: {
            color: options.colorSelected,
            colorSelection: options.colorSelection,
            colorBlacklist: options.colorBlacklist,
          },
        },
      ],
    });
  }

  ValidEmailCheck(email) {
    let emailPattern = new RegExp(
      "(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])"
    );
    return emailPattern.test(email);
  }

  OpenInfoPopup(header, descriptionLines, callbackAccept, callbackCancel) {
    let view = this;
    let entries = [];
    descriptionLines = descriptionLines.filter((l) => l && l !== "");
    for (let x in descriptionLines) {
      let style = { "text-align": "left" };
      let entry = {
        key: "info" + x,
        type: "output",
        value: descriptionLines[x],
        dataStyles: style,
      };
      if (x == descriptionLines.length - 1)
        entry.styles = { "margin-bottom": "-20px" };
      entries.push(entry);
    }
    let callbackAcceptWrapper;
    if (!callbackAccept)
      callbackAcceptWrapper = (entries, datafill) => {
        datafill.$parent.locked = false;
      };
    else
      callbackAcceptWrapper = (entries, datafill) => {
        datafill.locked = false;
        callbackAccept(entries, datafill);
      };
    let callbackCancelWrapper = undefined;
    if (callbackCancel)
      callbackCancelWrapper = (entries, datafill) => {
        datafill.$parent.locked = false;
        callbackCancel(entries, datafill);
      };
    this.OpenPopup({
      header: header,
      width: "500px",
      components: [
        {
          type: "datafill",
          state: {
            entries: entries,
            selectCallback: callbackAcceptWrapper,
            deleteCallback: callbackCancelWrapper,
            positiveButtonLabel: "Ok",
            negativeButtonLabel: "Abbrechen",
          },
        },
      ],
      centered: true,
      locked: true,
    });
  }

  MountViewOnDropdownContainer(view, options) {
    let state = {
      show: true,
      toggled: true,
      centered: true,
      expanded: true,
    };

    for (let o in options) {
      state[o] = options[o];
    }
    let containerState = this.OpenPopup(state);
    requestAnimationFrame(function () {
      let container = window.app.$children.find(
        (c) => c.state === containerState
      );
      if (container) {
        container.$el.querySelector(".tab-body").appendChild(view.$el);
        view.containerEl = container.$el;
        container.toggled = true;
        container.show = true;
        view.CloseCallback = () => {
          container.locked = false;
          requestAnimationFrame(function () {
            container.$emit("on-close", container);
          });
          /*view.$destroy();
          container.$destroy();*/
        };
        view.$once("hook:beforeDestroy", () => {
          container.locked = false;
          container.$emit("on-close", container);
          view.$destroy();
          container.$destroy();
        });
      }
    });
  }

  isFunction(x) {
    return Object.prototype.toString.call(x) == "[object Function]";
  }
}
